export default __webpack_public_path__ + "static/devops_a1_cloud_christian_p-eebe4294ebaa4bb4ec73019263d4d563.jpg";